import $api from "@/zapi-frontend/shared/api/axios";

export async function sendInvite({
  orgId,
  email,
  role,
  firstName,
  lastName
}: {
  orgId: string;
  email: string;
  role: string;
  firstName: string;
  lastName: string;
}) {
  const response = await $api.get(`/auth/generate-invite`, {
    params: {
      orgId,
      email,
      role,
      firstName,
      lastName
    }
  });

  return response.data;
}
